import { VerifyEmail } from "@features/account-recovery";

export const VerifyPage = () => <VerifyEmail />;
